/**
 * DemocratCharts — trading hotkeys.
 *
 *   B  → market Buy at current candle close (long)
 *   S  → market Sell at current candle close (short)
 *
 * Only active when there's a current candle context (i.e. chart is loaded).
 * Disabled inside input/textarea/contentEditable.
 */

import { useEffect } from "react";

interface UseTradingHotkeysParams {
  onBuy: () => void;
  onSell: () => void;
  enabled?: boolean;
}

export function useTradingHotkeys({ onBuy, onSell, enabled = true }: UseTradingHotkeysParams) {
  useEffect(() => {
    if (!enabled) return;
    const handler = (e: KeyboardEvent) => {
      const tag = (e.target as HTMLElement)?.tagName?.toLowerCase();
      const isEditable =
        tag === "input" ||
        tag === "textarea" ||
        tag === "select" ||
        (e.target as HTMLElement)?.isContentEditable;
      if (isEditable) return;
      if (e.metaKey || e.ctrlKey || e.altKey) return;

      switch (e.key) {
        case "b":
        case "B":
          e.preventDefault();
          onBuy();
          break;
        case "s":
        case "S":
          e.preventDefault();
          onSell();
          break;
      }
    };
    window.addEventListener("keydown", handler);
    return () => window.removeEventListener("keydown", handler);
  }, [enabled, onBuy, onSell]);
}
